
import React from 'react';

const ProductLabels = ({ product }) => {
  if (!product) return null;

  const { ribbon_top_left, ribbon_top_right, label_bottom_left, label_bottom_right } = product;

  return (
    <>
      {/* Top-left ribbon */}
      {ribbon_top_left?.text && (
        <div className="absolute top-0 left-0 w-48 h-48 overflow-hidden z-30">
          <div
            className="absolute transform -rotate-45 shadow-lg text-center"
            style={{
              backgroundColor: ribbon_top_left.background_color || '#e53e3e',
              color: ribbon_top_left.text_color || '#ffffff',
              fontSize: `${ribbon_top_left.font_size || 14}px`,
              fontWeight: ribbon_top_left.font_weight || 'bold',
              padding: '10px 0',
              width: '220px',
              left: '-40px',
              top: '45px',
              textShadow: '1px 1px 3px rgba(0,0,0,0.3)',
              letterSpacing: '0.5px'
            }}
          >
            {ribbon_top_left.text}
          </div>
        </div>
      )}

      {/* Top-right ribbon */}
      {ribbon_top_right?.text && (
        <div className="absolute top-0 right-0 w-48 h-48 overflow-hidden z-30">
          <div
            className="absolute transform rotate-45 shadow-lg text-center"
            style={{
              backgroundColor: ribbon_top_right.background_color || '#38a169',
              color: ribbon_top_right.text_color || '#ffffff',
              fontSize: `${ribbon_top_right.font_size || 14}px`,
              fontWeight: ribbon_top_right.font_weight || 'bold',
              padding: '10px 0',
              width: '220px',
              right: '-40px',
              top: '45px',
              textShadow: '1px 1px 3px rgba(0,0,0,0.3)',
              letterSpacing: '0.5px'
            }}
          >
            {ribbon_top_right.text}
          </div>
        </div>
      )}

      {/* Bottom-left label */}
      {label_bottom_left?.text && (
        <div
          className="absolute bottom-3 left-3 z-20 shadow-lg transform hover:scale-105 transition-transform"
          style={{
            backgroundColor: label_bottom_left.background_color || '#3182ce',
            color: label_bottom_left.text_color || '#ffffff',
            fontSize: `${label_bottom_left.font_size || 11}px`,
            fontWeight: label_bottom_left.font_weight || 'bold',
            padding: `${label_bottom_left.padding || 8}px ${(label_bottom_left.padding || 8) * 1.5}px`,
            borderRadius: '8px',
            border: '2px solid rgba(255,255,255,0.2)',
            backdropFilter: 'blur(4px)',
            textTransform: 'uppercase',
            letterSpacing: '0.5px'
          }}
        >
          {label_bottom_left.text}
        </div>
      )}

      {/* Bottom-right label */}
      {label_bottom_right?.text && (
        <div
          className="absolute bottom-3 right-3 z-20 shadow-lg transform hover:scale-105 transition-transform"
          style={{
            backgroundColor: label_bottom_right.background_color || '#d69e2e',
            color: label_bottom_right.text_color || '#ffffff',
            fontSize: `${label_bottom_right.font_size || 14}px`,
            fontWeight: label_bottom_right.font_weight || 'bold',
            padding: `${label_bottom_right.padding || 10}px`,
            borderRadius: '50%',
            width: '50px',
            height: '50px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: '3px solid rgba(255,255,255,0.9)',
            textAlign: 'center',
            lineHeight: '1'
          }}
        >
          {label_bottom_right.text}
        </div>
      )}
    </>
  );
};

export default ProductLabels;
